import { useEffect, useRef, useState } from "react";
import BoardingReview from "../TenantOnboard/RenderSteps/BoardingReview";
import { TemplateService } from "@propertelligent/client-api";
import { handleDownloadPdf } from "../../utils/validateHelper";
import SimpleButton from "../../newComponents/buttons/Simple-button";
import LeftArrowTopHeader from "../../newComponents/form-fields/LeftArrowTopHeader";
import EmptyState from "../../newComponents/emptystate";
import { GetImages } from "../../utils/GetImages";

interface ViewApplicationProps {
  tenantData?: any;
  path?: string;
}

const LeaseApplication: React.FC<ViewApplicationProps> = ({
  tenantData: tenantData,
  path=undefined,
}) => {
  const [postData, setPostData] = useState<any | undefined>();

  const [isPrint, setIsPrint] = useState(false);
  const contentRef = useRef(null);

  const id = tenantData?.templateId;
  useEffect(() => {
    if (id) {
      getTempleteData();
    }
  }, [id]);

  const getTempleteData = () => {
    TemplateService.getApiTemplate(Number(id))
      .then((res) => {
        if (res?.success) {
          setPostData(res?.success);
        }
      })
      .catch((err) => {});
  };

  const cleanPathname = location.pathname.replace(/^\/+|\/+$/g, "");
  const generatePdf = cleanPathname.startsWith("generatePdfDocument");

  useEffect(() => {
    if (generatePdf && postData) {
      setTimeout(() => {
        handleDownload();
      }, 1500);
    }
  }, [generatePdf, postData]);

  const handleDownload = () => {
    const fileName = `LeaseApplication-${tenantData?.currentLeaseApplicationId}.pdf`;

    handleDownloadPdf(setIsPrint, contentRef, fileName);
  };
  const backPath = path || "/";
  return (
    <div>
      {tenantData?.usedLeaseApplicationTemplate && (
        <>
          <div className="top-listing-header-top">
            <LeftArrowTopHeader title="Lease Application" backPath={backPath} />

            <SimpleButton
              label={"Download Application"}
              onClick={handleDownload}
            />
          </div>

          <div ref={contentRef}>
            <BoardingReview
              leaseApplicationId={tenantData?.currentLeaseApplicationId}
              postData={postData}
              editable={false}
              isEditClick={undefined}
              formData={undefined}
              setFormData={undefined}
              steps={undefined}
            />
          </div>
        </>
      )}

      {!tenantData?.usedLeaseApplicationTemplate &&
        !tenantData?.currentLeaseApplicationDocumentId && (
          <div className="lease-download-container">
            {/* Top Center Header */}
            <div className="lease-header-center">
              <LeftArrowTopHeader title="Lease Application" backPath={"/"} />
            </div>
            <div className="no-lease-agreement">
              <EmptyState
                icon={GetImages.leaseAgreementAvatar}
                className="bg-transparent"
                isBorder={false}
                heading="No Lease Application Found"
                isButton={false}
              />
            </div>
          </div>
        )}
    </div>
  );
};

export default LeaseApplication;
